import getConfig from 'next/config';

export function getApiPartnerBaseUrl() {
  const { publicRuntimeConfig } = getConfig();
  const { CONTENTFUL_ENVIRONMENT } = publicRuntimeConfig;

  return CONTENTFUL_ENVIRONMENT === 'staging'
    ? 'https://api-partner.spotify.com/ads-sandbox/v3'
    : 'https://api-partner.spotify.com/ads/v3';
}
